export interface ForemanDailyTask {
  foremanDailyTaskID: string;
  foremanTaskID: string;
  foremanJobID: string;
  dateWorked: Date;
  shift: number;
  foremanJobCrewID: string;
  taskOrder: number;
  taskDescription: string;
  isFavorite: boolean;
  isNextShiftTask: boolean;
  bActive: boolean;
}
